import dateFormat from './module/dateFormat';
import { numberFormat } from './module/numberFormat';
import arrayToString from './module/arrayToString';
import tScope from './module/tScope';
import tAction from './module/tAction';
import tMAttr from './module/tMAttr';
import tDevType from './module/tDevType';
import tStructureType from './module/tStructureType';
import tDevCategory from './module/tDevCategory';
import tField from './module/tField';

const filters = {
  dateFormat,
  numberFormat,
  arrayToString,
  tScope,
  tAction,
  tMAttr,
  tDevType,
  tStructureType,
  tDevCategory,
  tField,
};

export default filters;
